/**
 * SB6-AUTH-RECONNECT-01 — shared timing constants.
 *
 * IDLE_MAX: a successful refresh is silent. If the refresh fails AND the
 * user has been idle (no mouse/keyboard activity) for at least this long,
 * we surface the soft-prompt modal-over-current-page. Otherwise we leave
 * the original 401 surface to the caller and continue retrying silently.
 *
 * HARD_CAP: absolute session length regardless of activity. After this
 * the session is fully cleared and the user must re-auth from /login.
 *
 * REFRESH_SAFETY_MARGIN_MS: how long BEFORE the access-token deadline the
 * proactive timer fires the refresh. 60 s gives us plenty of slack to
 * reach Zitadel even on a slow link before the access token is rejected
 * server-side.
 *
 * Defaults chosen 2026-05-25 per Christian's auto-mode brief; matches
 * Google / Microsoft consumer-product behaviour.
 */

export const IDLE_MAX_MS = 8 * 60 * 60 * 1000; // 8 hours
export const HARD_CAP_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
export const REFRESH_SAFETY_MARGIN_MS = 60 * 1000; // 60 seconds
/** Throttle window for activity-tracker writes to the Zustand store. */
export const ACTIVITY_THROTTLE_MS = 30 * 1000; // 30 seconds
